module.exports = __webpack_public_path__ + "img/55e52ab.png";